/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import RequirementsContainer from './requirements/container/RequirementsContainer';
import SystemModulesContainer from './modules/container/SystemModulesContainer';
import CitizenshipContainer from './citizenship/container/SettingsContainer';
import AddressContainer from './address/SettingsContainer';
import InstitutionContainer from './institution/container/InstitutionContainer';
import HospitalContainer from './hospitals/container/HospitalContainer';
import ProfessionContainer from './profession/container/ProfessionContainer';
import OTPModuleContainer from './otpModule/container/OTPModuleContainer';
import BussEstSettingsContainer from './businessEstablishments/container/BussEstSettingsContainer';
import CMSContainer from './cms/container/CMSContainer';
import CSVUploadContainer from './csv-upload/container/CSVUploadContainer';
import TemplatesContainer from './templates/container/TemplatesContainer';
import HowToContainer from './how-to/HowToContainer';
import FaqsContainer from './faqs/FaqsContainer';

function SettingsContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <Switch>
      {Acl(permissions, ['VIEW CITIZENSHIP GENERAL SETTINGS']) && (
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/citizenship`} />}
        />
      )}
      {Acl(permissions, ['VIEW SYSTEM MODULE GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/system-modules`}
          component={SystemModulesContainer}
        />
      )}
      {Acl(permissions, ['VIEW OTP GENERAL SETTINGS']) && ( // replace with OTP modules later
        <Route
          path={`${match.path}/otp-modules`}
          component={OTPModuleContainer}
        />
      )}
      {Acl(permissions, ['VIEW BUSINESS ESTABLISHMENT GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/business-establishments`}
          component={BussEstSettingsContainer}
        />
      )}
      {Acl(permissions, ['VIEW REQUIREMENT GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/requirements`}
          component={RequirementsContainer}
        />
      )}
      {Acl(permissions, ['VIEW CITIZENSHIP GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/citizenship`}
          component={CitizenshipContainer}
        />
      )}
      {Acl(permissions, ['VIEW ADDRESS GENERAL SETTINGS']) && (
        <Route path={`${match.path}/address`} component={AddressContainer} />
      )}
      {Acl(permissions, ['VIEW INSTITUTION GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/institution`}
          component={InstitutionContainer}
        />
      )}
      {Acl(permissions, ['VIEW HOSPITAL GENERAL SETTINGS']) && (
        <Route path={`${match.path}/hospitals`} component={HospitalContainer} />
      )}
      {Acl(permissions, ['VIEW PROFESSION GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/profession`}
          component={ProfessionContainer}
        />
      )}
      {Acl(permissions, ['VIEW CMS GENERAL SETTINGS']) && (
        <Route path={`${match.path}/cms/:type?`} component={CMSContainer} />
      )}
      {Acl(permissions, ['VIEW CSV UPLOAD GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/csv-upload`}
          component={CSVUploadContainer}
        />
      )}
      {Acl(permissions, ['VIEW TEMPLATE GENERAL SETTINGS']) && (
        <Route path={`${match.path}/templates`} component={TemplatesContainer} />
      )}
      {Acl(permissions, ['VIEW HOW TO GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/how-to`}
          component={HowToContainer}
        />
      )}
      {Acl(permissions, ['VIEW FAQ GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/faqs`}
          component={FaqsContainer}
        />
      )}
    </Switch>
  );
}

SettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(SettingsContainer);
